var React = require('react');

function FlagCz (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.256 421.59L256 256 3.256 90.41C1.311 92.029 0 94.375 0 97.103v317.793c0 2.729 1.311 5.075 3.256 6.694z","fill":"#41479b","key":0}),React.createElement("path",{"d":"M3.256 421.59c1.53 1.274 3.425 2.134 5.571 2.134h494.345a8.829 8.829 0 008.828-8.828V256H256L3.256 421.59z","fill":"#ff4b55","key":1}),React.createElement("path",{"d":"M3.256 90.41c1.53-1.274 3.425-2.134 5.571-2.134h494.345A8.829 8.829 0 01512 97.104V256H256L3.256 90.41z","fill":"#f5f5f5","key":2})]);
}

FlagCz.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = FlagCz;

FlagCz.default = FlagCz;
